import React, {useEffect, useMemo, useState} from 'react';
import Search from "../../../../components/search/Search";
import {NOTIFICATION_HEADER} from "../../../../components/table/header/Headers";
import SearchSection from "../../../../components/search/SearchSection";
import {searchListener} from "../../../../components/commonmethod/simmsDrawerMethod";
import Selector from "../../../../components/selector/Selector";
import {getIndividualSetting, resetIndividualSetting, setIndividualSetting} from "../../../../api/user/UserAccountService";
import {extractObject, initHeaderOrders, nonObject, simmsColumnsToJsGridHeaders} from "../../../../components/commonmethod/CommonMethod";
import {SearchComboBox} from "../../../../components/select/SearchComboBox";
import SimmsInputSearch from "../../../../components/input/SimmsInputSearch";
import SimmsJsGrid from "../../../../components/js-grid/SimmsJsGrid";
import {useExcelDownloadClick} from "../../../../components/commonmethod/excelMethod";
import JsGridExcelGridOpenButton from "../../../../components/js-grid/JsGridExcelGridOpenButton";
const NotificationListType = ({data, date, pageInfo, dataHook, conditions}) => {
    const {handleSearch, handlePageSizeChange, saveConditions, refresh, handleGridPageChange} = dataHook;

    const [header, setHeader] = useState({order: NOTIFICATION_HEADER, exclude: []});

    const searchDate = {
        startDate: saveConditions.startDate ?? date.startDate,
        endDate: saveConditions.endDate ?? date.endDate,
    };

    useEffect(() => {
        getIndividualSetting().then((r) => {
            initHeaderOrders(r, NOTIFICATION_HEADER, setHeader, [], () => {}, () => {}, 'notification');
        });
    }, []);

    const notificationJsGridHeader = useMemo(() => simmsColumnsToJsGridHeaders(header), [header]);
    const excelGridSearch = useMemo(() => extractObject(saveConditions), [saveConditions]);
    const handleDownloadClick = useExcelDownloadClick(saveConditions);

    return (
        <div className="container-height">
            <Search
                refresh={refresh}
                entity="notification"
                searchConditions={saveConditions}
                handleSearch={handleSearch}
                handlePageSizeChange={handlePageSizeChange}
                size
                detail
                date={searchDate}
                pageInfo={pageInfo}
            >
                <SearchSection>
                    <Selector
                        showLabel
                        onChange={(value) => searchListener(handleSearch, 'toUser', extractObject(saveConditions), value)}
                        data={saveConditions.toUser}
                        uniqueKey="toUser"
                        entity="userAccount"
                        title="수신자"
                    >
                        <SimmsInputSearch type="TEXT" placeHolder="사용자명" />
                    </Selector>
                    <SearchComboBox
                        title="카테고리"
                        code={conditions.alamContentCategories}
                        target="contentCategory"
                        value={saveConditions}
                        onChange={(v) => nonObject(saveConditions, v, handleSearch, "contentCategory")}
                    />
                    <SearchComboBox
                        title="알림종류"
                        code={conditions.alarmType}
                        target="alarmType"
                        value={saveConditions}
                        onChange={(v) => nonObject(saveConditions, v, handleSearch, "alarmType")}
                    />
                </SearchSection>
            </Search>

            <div className="container-height-body">
                <SimmsJsGrid
                    loading={dataHook.loading}
                    resizable={true}
                    data={data}
                    theme="linear"
                    style={{minHeight: 0, height: '100%'}}
                    header={notificationJsGridHeader}
                    onHeaderSave={(v) => setIndividualSetting({headers: {notification: v}})}
                    onHeaderReset={() => resetIndividualSetting('headers', 'notification')}
                    onPageChange={handleGridPageChange}
                    toolbarEnd={() => (
                        <div className="flex items-center gap-2">
                            <JsGridExcelGridOpenButton entityName="Notification" search={excelGridSearch} />
                        </div>
                    )}
                />
            </div>
        </div>
    );
};

export default NotificationListType;
